import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2AB3BA',
        secondary: '#53BE8C',
        accent: '#A8CC47',
        error: '#CC2020',
        success: '#53BE8C',
      },
    },
  },
});
